import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const notacobroSlice = createSlice({
  name: 'notacobro',
  initialState: {
    folio: 0,
    cabecera: null,
    cargos: []
  },
  reducers: {
    setNotaCobro: (state, action) => {
      state.folio = action.payload.folio;
      state.cabecera = action.payload.cabecera;
      state.cargos = action.payload.cargos;
    }
  }
});

export const { setNotaCobro } = notacobroSlice.actions;

// Action Creators
export const getNotaCobro = (comunidadId, folio) => async (dispatch, getState) => {
  let item = LocalCache.get(`KEY:notacobro&comunidad=${comunidadId}&folio=${folio}`);
  if (item) {
    dispatch(setNotaCobro(item));
  } else {
    try {
      const response = await API.get('ePlat', `/get-notacobro?comunidad=${comunidadId}&folio=${folio}`);
      let notacobro = { folio: folio, cabecera: response.notacobro, cargos: response.cargos };
      dispatch(setNotaCobro(notacobro));
      LocalCache.put(`KEY:notacobro&comunidad=${comunidadId}&folio=${folio}`, notacobro);
    } catch (error) {
      console.log('DVD: ERROR Llamada a getNotaCobro()', error);
    }
  }
};

export default notacobroSlice.reducer;
